import {
    DISABLE_APPLIED_FILTER, ENABLE_APPLIED_FILTER,
    REGISTER_APPLIED_FILTER
} from "../../actions/FilterGroupsActions";
import {CLEAR_FILTER, RESET_ALL_FILTERS} from "../../actions/FlightsActions";

const initialState = {
    groups: {} //{filter, name, enabled, remove}
};

const FilterGroupsReducer = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER_APPLIED_FILTER:
            if (!state.groups.hasOwnProperty(action.filter)) {
                let groups = state.groups;
                groups[action.filter] = {
                    name: action.name,
                    filter: action.filter,
                    enabled: action.enabled,
                    remove: action.remove
                };

                return {
                    ...state, groups: groups
                };
            }

            return state;
        case ENABLE_APPLIED_FILTER:
            let stateGroups = state.groups;
            stateGroups[action.filter].enabled = true;

            return {...state, groups: stateGroups};
        case DISABLE_APPLIED_FILTER:
            let groups = state.groups;
            groups[action.group].enabled = false;

            return {...state, groups: groups};
        case CLEAR_FILTER:
            let unclearGroups = state.groups;
            unclearGroups[action.filter].enabled = false;

            return {...state, groups: unclearGroups};
        case RESET_ALL_FILTERS:
            let disabledGroups = {};
            Object.keys(state.groups).map((key) => {
                disabledGroups[key] = state.groups[key];
                disabledGroups[key].enabled = false;

                return disabledGroups;
            });
            return {...state, groups: disabledGroups};
        default:
            return state
    }
};

export default FilterGroupsReducer;



// WEBPACK FOOTER //
// ./src/reducers/filters/FilterGroupsReducer.js